import React from 'react';
import styled from '@emotion/styled';
import { text } from 'style/mixin';
import sizes from 'style/sizes';
import { useStaticQuery, graphql } from 'gatsby';
import { AwardsQuery } from 'types/graphql-types';
import Img from 'components/atoms/img';

export type AwardProps = {
  award: string;
  label?: string;
  win?: string;
  to?: string;
};

const LinkContainer = styled.a`
  display: block;
  transition: 0.8s;
  &:hover {
    opacity: 0.5;
  }
`;

const Container = styled.div`
  display: block;
`;

const ImgWrap = styled('div')`
  display: block;
  max-height: 76px;
  margin-bottom: ${sizes.margin[49]};

  img {
    max-height: 76px;
    object-fit: contain !important;
    object-position: center left !important;
  }
`;

const Texts = styled.div`
  ${text(15, 1.6)}
`;

export const htmlscd = (text: string | null | undefined) => {
  const conv_regexp = new RegExp('&#([0-9]+);', 'gi');
  if (typeof text === 'string') {
    return text.replace(conv_regexp, (_, subMatch1) => String.fromCharCode(parseInt(subMatch1)));
  } else {
    return text;
  }
};

export const Award: React.FC<AwardProps> = props => {
  const awards: AwardsQuery = useStaticQuery(
    graphql`
      query Awards {
        allShifterAwardsData(filter: { title: { rendered: { nin: ["dummy", null] } } }) {
          edges {
            node {
              title {
                rendered
              }
              acf {
                logo
              }
            }
          }
        }
      }
    `
  );

  const imgPath = awards.allShifterAwardsData.edges.find(award => htmlscd(award.node.title?.rendered) === props.award)
    ?.node.acf?.logo;

  return (
    <>
      {props.to ? (
        <LinkContainer href={props.to} target="_blank">
          <ImgWrap>
            <Img filename={imgPath || ''} alt="" />
          </ImgWrap>
          <Texts>
            {props.label && <div dangerouslySetInnerHTML={{ __html: props.label }} />}
            {props.win && <p>{props.win}</p>}
          </Texts>
        </LinkContainer>
      ) : (
        <Container>
          <ImgWrap>
            <Img filename={imgPath || ''} alt="" />
          </ImgWrap>
          <Texts>
            {props.label && <div dangerouslySetInnerHTML={{ __html: props.label }} />}
            {props.win && <p>{props.win}</p>}
          </Texts>
        </Container>
      )}
    </>
  );
};
